import { Component, Vue } from "vue-property-decorator";
import { getCookies, srollFunction } from "@/libs/util";
import JsBridge from "@/libs/jsBridge";
import Info from '../../components/info.vue';
import Rank from '../../components/ranking.vue';
@Component({
  components:{
    Info,
    Rank
  }
})
export default class Index extends Vue {
  isShow: boolean = false;
  isPledged: boolean = false;
  isShowPicker:boolean = false;
  count:number = 1;
  areaList:any =  ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'];
  areaName:string = '';
  provinceId:string = '';
  provinceList:any = [];
  certUrl:string = ''; //认捐图片
  identifyUrl:string = ''; //认证图片
  showName:string = '';
  picUrl:string = '';
  created() {
    // 初始化方法
    (window as any).loginSuccessCallback = this.loginSuccessCallback;
    (window as any).shareCallback = this.shareCallback;
    JsBridge.callShowTopNavigation({});
    if(getCookies().zwzt_code){
      this.getUserInfo();
      this.getProvinceList();
    }
  }
  getUserInfo(){
    this.ajax({
      method:'get',
      url:'/api/donate/userInfo'
    }).then((res:any)=>{
      this.certUrl = res.data.certUrl || '';
      this.identifyUrl = res.data.identifyUrl || '';
      this.showName =res.data.showName;
      this.picUrl = res.data.picUrl;
    }).catch((err)=>{

    })
  }
  getProvinceList(){
    this.ajax({
      url:'/api/province/list',
      method:'get'
    }).then((res:any)=>{
      this.provinceList = res.data;
      this.areaList = res.data.map((item:any)=>{
        return item.name;
      })
    })
  }
  onShare(){
    // (window as any)._czc.push(['_trackEvent','首页','分享','公益图书馆','1','share'])
    let data = {
      title: '我正在筹建一间乡村公益图书室，快来加入我吧！',
      detail: '我已经加入了“纸条公益图书室2024计划”：将旧书变新知，在知识的边疆，我们益路同行。',
      url: `${window.location.origin}/share`,
      thumbUrl: 'https://wx-oss.zuowenzhitiao.com/zwzt-h5-image/gongyiLogo.png',
      shareType: [1, 2, 3, 4, 5],
      contentType: 1,
    };
    JsBridge.callShareObject(JSON.stringify(data));
   
  }
  shareCallback(){

  }
  onShowRank(){
    this.isShow = true;
    srollFunction.afterOpen(document.body, 'nomove');
  }
  onCloseRank(){
    this.isShow = false;
    srollFunction.beforeClose(document.body, 'nomove');
  }
  onDonation(){
    if(getCookies().zwzt_code){
      this.ajax({
        method:'get',
        url:'/api/donate/userInfo'
      }).then((res:any)=>{
        if(res.data.certUrl && res.data.certUrl !== ''){
          this.$router.push({path: '/myCenter'})
          return;
        }
        if(res.data.identifyUrl && res.data.identifyUrl !== ''){
          this.$router.push({path: '/donation'})
          return;
        }
        this.isPledged = true;
       
      }).catch((err)=>{
        
      })
    }else{
      this.$dialog.confirm({
        message: '登录后才能参加本次活动哦~',
        className:'dialogBox',
        confirmButtonColor:'#3e3c3d',
        cancelButtonText:'先不了,谢谢',
        confirmButtonText:'去登录'
      }).then(() => {
        this.onLogin();
      }).catch(() => {
        // on cancel
      });
    }
  }
  onCancalDonation(){
    this.isPledged = false;
  }
  onSubmit(){
    if(this.areaName === ''){
      this.$toast('请填写完整再提交');
      return;
    }
    const Toast = this.$toast.loading({
      message: '数据提交中...',
      duration:0,
      forbidClick: true,
    })
    this.ajax({
      url:'/api/donate/save',
      method:'get',
      params:{
        provinceId:this.provinceId,
        num:this.count
      }
    }).then((res:any)=>{
      Toast.clear();
      this.$router.push({path: '/donation'})
    }).catch((err)=>{
      this.$toast(err.data.msg);
    })
    
  }
  // 登录
  onLogin() {
    JsBridge.routerToPage('zuowenzhitiao://account/login', () => {});
  }
  // 登录回调方法
  loginSuccessCallback() {
    window.location.reload();
  }
  onShowPicker(){
    this.isShowPicker = true;
  }
  onCancel(){
    this.isShowPicker = false;
  }
  onConfirm(value:any,index:number){
    this.isShowPicker = false;
    this.areaName = value;
    this.provinceId = this.provinceList[index].id;
  }
}
